module.exports = __webpack_public_path__ + "img/periodo.3560957a.png";